import { BasketClient } from '@frontend/basket/api';
import { Basket } from '@frontend/basket/types';
import { EntityType, Rights } from '@frontend/common';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { CommonMessage } from '@frontend/lang';
import { useAccountRepository } from '@frontend/repository';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../redux/store';

const ID = 'basket-overview';
export const BasketOverview = () => {
    const { currentAccount } = useAccountRepository();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    return (
        <ReactiveObjectList<Basket>
            id={ID}
            useStaticListId
            type={EntityType.BASKET}
            dispatch={dispatch}
            fetch={(arg) => BasketClient.fetchBaskets(arg)}
            eventListener={EntityType.BASKET}
            create={{
                label: CommonMessage.OBJECTS.BASKET.DEFAULT,
                onCreate: () => navigate('./create'),
                requiredPermissions: [{ item: EntityType.BASKET, source: EntityType.ACCOUNT, right: Rights.CREATE, uid: currentAccount }]
            }}
            onSelectElement={(obj) => navigate(`/accounts/${obj.account_id}/baskets/${obj.id}/detail`)}
            columns={{
                showIdAsEntity: EntityType.BASKET,
                columns: ['id', 'spot_id', 'status', 'user_id'],
                delete: {
                    deleteAction: (accountId: string, basketId: string) => BasketClient.deleteBasket(accountId, basketId),
                    deleteKeys: ['account_id', 'id'],
                    displayName: (o) => o.id
                },
                update: {
                    updateAction: (o) => navigate(`/accounts/${o.account_id}/baskets/${o.id}/update`)
                }
            }}
            filter={{ default: true }}
            showCount
        />
    );
};
